import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export const propertyQueryKeys = {
  all: ['accommodation', 'properties'] as const,
  createSchema: () => [...propertyQueryKeys.all, 'create-schema'] as const,
  details: () => [...propertyQueryKeys.all, 'detail'] as const,
  detail: (propertyId?: string) => [...propertyQueryKeys.details(), propertyId] as const,
};

interface UseGetPropertyParams {
  propertyId?: string;
  enabled?: boolean;
}

export function useGetProperty<TProperty extends App.Property = App.Property>({
  propertyId,
  enabled = true,
}: UseGetPropertyParams) {
  return useQuery<TProperty>({
    queryKey: propertyQueryKeys.detail(propertyId),
    queryFn: async ({ signal }) => {
      const response = await ReservationService.getProperty(propertyId, { signal });
      return response.result as TProperty;
    },
    enabled: enabled && !!propertyId,
  });
}

export function useGetPropertiesSchema(enabled = true) {
  return useQuery({
    queryKey: propertyQueryKeys.createSchema(),
    queryFn: async () => {
      const response = await ReservationService.getPropertiesSchema();
      return response.post.body.schema;
    },
    enabled,
  });
}
